var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4003 0.645619C58.5642 1.45209 59.175 2.84614 58.956 4.24019L51.5809 52.1678C51.408 53.2853 50.7281 54.2646 49.7371 54.8176C48.7461 55.3706 47.5592 55.4397 46.5105 55.0019L32.7283 49.276L24.8346 57.8131C23.809 58.9306 22.1957 59.2993 20.7783 58.7463C19.3609 58.1933 18.439 56.8223 18.439 55.3015V45.6699C18.439 45.209 18.6118 44.7712 18.923 44.4256L38.2365 23.3651C38.9049 22.6393 38.8819 21.5218 38.1905 20.8305C37.499 20.1392 36.3812 20.0932 35.6553 20.7499L12.2162 41.5684L2.04088 36.4761C0.819377 35.8655 0.0357711 34.6442 0.00120025 33.2848C-0.0333706 31.9253 0.681094 30.658 1.8565 29.9782L53.4823 0.484325C54.7153 -0.218459 56.2364 -0.149333 57.4003 0.645619Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a03ba3a1bc3de2d51cd018093f307b13.svg";
export { ForwardRef as ReactComponent };